import { Injectable, signal } from '@angular/core';
import { ToastInterface } from '../interfaces/toast-interface';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

    private _messages = signal<ToastInterface[]>([]);
    public messages = this._messages.asReadonly();

    show(message: ToastInterface) {
        const life = message.life ?? 4000;

        // Agregar mensaje
        const list = [...this._messages()];
        list.push(message);
        this._messages.set(list);

        // Quitar después del tiempo
        setTimeout(() => this.remove(message), life);
    }

    remove(message: ToastInterface) {
        this._messages.update(list => list.filter(m => m !== message));
    }
}
